interface ITheme {
  textPrimary: string;
  textSecondary: string;
  textTertiary: string;
  textQuaternary: string;
  bgPrimary: string;
  bgSecondary: string;
  bgTertiary: string;
  btnTextPrimary: string;
  btnTextSecondary: string;
  btnTextTertiary: string;
  btnBgPrimary: string;
  btnBgSecondary: string;
  btnBgTertiary: string;
  modalDim: string;
}

/**
 * TUNE default theme
 */
const DEFAULT_THEME: ITheme = {
  textPrimary: "0 0 0",
  textSecondary: "139 139 139",
  textTertiary: "190 190 190",
  textQuaternary: "255 255 255",

  bgPrimary: "255 255 255",
  bgSecondary: "112 112 112",
  bgTertiary: "240 240 240",

  btnTextPrimary: "255 255 255",
  btnTextSecondary: "0 0 0",
  btnTextTertiary: "139 139 139",

  btnBgPrimary: "0 0 0",
  btnBgSecondary: "217 217 217",
  btnBgTertiary: "255 255 255",

  modalDim: "0 0 0, 50",
};

type TPageCustomTheme = Record<
  string,
  {
    textPrimary: string;
    textSecondary: string;
    bgPrimary: string;
  }
>;

export const pageCustomTheme: TPageCustomTheme = {
  brands: {
    textPrimary: "255 255 255",
    textSecondary: "190 190 190",
    bgPrimary: "112 112 112",
  },
};

/**
 * 커스텀 테마 적용
 * @param defaultTheme - 기본 테마
 */
function useCustomTheme(defaultTheme: ITheme = DEFAULT_THEME): {
  defaultTheme: ITheme;
  changeTheme: (theme: Partial<ITheme>) => ITheme;
} {
  const setStyleProp = (name: string, value: string): void => {
    document.documentElement.style.setProperty(name, value);
  };

  const changeTheme = (_theme: Partial<ITheme> = {}): ITheme => {
    const theme = { ...defaultTheme, ..._theme };
    setStyleProp("--text-primary", theme.textPrimary);
    setStyleProp("--text-secondary", theme.textSecondary);
    setStyleProp("--text-tertiary", theme.textTertiary);
    setStyleProp("--text-quaternary", theme.textQuaternary);

    setStyleProp("--bg-primary", theme.bgPrimary);
    setStyleProp("--bg-secondary", theme.bgSecondary);
    setStyleProp("--bg-tertiary", theme.bgTertiary);

    setStyleProp("--btn-text-primary", theme.btnTextPrimary);
    setStyleProp("--btn-text-secondary", theme.btnTextSecondary);
    setStyleProp("--btn-text-tertiary", theme.btnTextTertiary);

    setStyleProp("--btn-bg-primary", theme.btnBgPrimary);
    setStyleProp("--btn-bg-secondary", theme.btnBgSecondary);
    setStyleProp("--btn-bg-tertiary", theme.btnBgTertiary);

    return theme;
  };

  return { defaultTheme: DEFAULT_THEME, changeTheme };
}

export default useCustomTheme;
